export default __webpack_public_path__ + "static/media/badges_sprite.7213ae81.png";